import { env } from 'lib/env';
import { logWarning } from 'lib/util/errors';
import Script from 'next/script';

const ObservabilityInitDynatrace = () => {
  let enableRum = env.NEXT_PUBLIC_RUM_ENABLED;
  let scriptSrc = '';
  if (enableRum) {
    if (
      !env.NEXT_PUBLIC_DYNATRACE_TENANT_ID ||
      !env.NEXT_PUBLIC_DYNATRACE_APPLICATION_ID ||
      !env.NEXT_PUBLIC_DYNATRACE_INSTANCE_ID
    ) {
      logWarning(
        `Dynatrace RUM configuration invalid; Please check environment variables.\n\tNEXT_PUBLIC_DYNATRACE_TENANT_ID=${env.NEXT_PUBLIC_DYNATRACE_TENANT_ID}\n\tNEXT_PUBLIC_DYNATRACE_APPLICATION_ID=${env.NEXT_PUBLIC_DYNATRACE_APPLICATION_ID}\n\tNEXT_PUBLIC_DYNATRACE_INSTANCE_ID=${env.NEXT_PUBLIC_DYNATRACE_INSTANCE_ID}`
      );
      enableRum = false;
    } else {
      scriptSrc = `https://js-cdn.dynatrace.com/jstag/${env.NEXT_PUBLIC_DYNATRACE_TENANT_ID}/${env.NEXT_PUBLIC_DYNATRACE_APPLICATION_ID}/${env.NEXT_PUBLIC_DYNATRACE_INSTANCE_ID}_complete.js`;
    }
  }

  return (
    <>
      {enableRum && <Script src={scriptSrc} strategy="afterInteractive" crossOrigin="anonymous" />}
    </>
  );
};

export default ObservabilityInitDynatrace;
